export const SITE = {
  name: "The Formulation House",
  url: "https://www.theformulationhouse.com",
  email: "drarathi@theformulationhouse.com",
  ogImage:
    "https://static.prod-images.emergentagent.com/jobs/9444b1cb-2cbd-41d7-b086-be1e8cd6725c/images/70d9cc383191cf7fcff2dd226738b539d152b799f0ee1aba693893748b5a3ed9.jpeg",
};

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": ["Organization", "ProfessionalService"],
  "@id": `${SITE.url}/#organization`,
  name: SITE.name,
  url: `${SITE.url}/`,
  email: SITE.email,
  logo: `${SITE.url}/logo-512.png`,
  image: SITE.ogImage,
  description:
    "Doctor-led formulation and product development studio for beauty, wellness and Ayurvedic brands across cosmetics, Ayurveda and nutraceuticals.",
  areaServed: ["IN", "Worldwide"],
  knowsAbout: ["Cosmetic Formulation", "Skincare Formulation", "Haircare Formulation", "Ayurveda", "Nutraceuticals", "Product Development", "Regulatory Support", "Private Label Cosmetics"],
};

export const absoluteUrl = (path) => `${SITE.url}${path === "/" ? "/" : path}`;

export const serviceSchema = ({ path, name, description, serviceType }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": `${absoluteUrl(path)}#service`,
  name,
  serviceType,
  description,
  url: absoluteUrl(path),
  provider: { "@id": `${SITE.url}/#organization` },
  areaServed: ["IN", "Worldwide"],
});

export const webPageSchema = ({ path, title, description, type = "WebPage" }) => ({
  "@context": "https://schema.org",
  "@type": type,
  "@id": `${absoluteUrl(path)}#webpage`,
  url: absoluteUrl(path),
  name: title,
  description,
  isPartOf: { "@id": `${SITE.url}/#website` },
  about: { "@id": `${SITE.url}/#organization` },
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(({ name, path }, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name,
    item: absoluteUrl(path),
  })),
});
